import { RoomType } from "building-types/rooms/roomTypesEnum";
import type { FloorAreaTakeoffConfig } from "building-types/rooms/takeoffTypes";
import {
  AreaRuleType,
  BorderPosition,
  FloorAreaTakeoffType,
  FloorFilter,
  RoomSelectorType,
  SupplementalArea,
} from "building-types/rooms/takeoffTypes";

export const FloorAreaTakeoffConfigsV2: { [key in FloorAreaTakeoffType]?: FloorAreaTakeoffConfig } = {
  [FloorAreaTakeoffType.UNCONDITIONED_FLOOR_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_SELECTOR,
        roomSelectors: [RoomSelectorType.UNCONDITIONED],
        includeAnyInSameRoomSets: false,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
        specificRoomBorderPositions: [
          {
            type: AreaRuleType.BY_ROOM_SELECTOR,
            roomSelectors: [RoomSelectorType.NOT_CONDITIONED_OR_UNCONDITIONED],
            borderPosition: BorderPosition.FRAMING_OUTSIDE,
          },
        ],
      },
    ],
    exclude: [],
  },
  [FloorAreaTakeoffType.TOTAL_GARAGE_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.GARAGE]: true,
        },
        includeAnyInSameRoomSets: true,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
        specificRoomBorderPositions: [
          {
            type: AreaRuleType.BY_ROOM_TYPE,
            roomTypes: {
              [RoomType.PATIO]: true,
              [RoomType.FRONT_PORCH]: true,
              [RoomType.REAR_PORCH]: true,
              [RoomType.WALK]: true,
              [RoomType.BREEZEWAY]: true,
              [RoomType.FREESTANDING_FIREPLACE]: true,
              [RoomType.LANDSCAPE]: true,
            },
            borderPosition: BorderPosition.FRAMING_OUTSIDE,
          },
        ],
      },
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.GARAGE_DETACH]: true,
        },
        includeAnyInSameRoomSets: true,
        otherRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
        exteriorRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
      },
    ],
    exclude: [],
  },
  [FloorAreaTakeoffType.FRONT_PORCH_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.FRONT_PORCH]: true,
          [RoomType.PORTICO]: true,
        },
        includeAnyInSameRoomSets: false,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.CENTERLINE,
      },
    ],
    exclude: [],
    includeSupplementalAreas: { [SupplementalArea.FRONT_PORCH_COLONNADE]: true },
  },
  [FloorAreaTakeoffType.REAR_PORCH_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.REAR_PORCH]: true,
        },
        includeAnyInSameRoomSets: false,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.CENTERLINE,
      },
    ],
    exclude: [],
    includeSupplementalAreas: { [SupplementalArea.REAR_PORCH_COLONNADE]: true },
  },
  [FloorAreaTakeoffType.COVERED_PATIO_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.BREEZEWAY]: true,
        },
        includeAnyInSameRoomSets: false,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.CENTERLINE,
      },
    ],
    exclude: [],
  },
  [FloorAreaTakeoffType.UNCOVERED_PATIO_AREA]: {
    include: [
      {
        type: AreaRuleType.BY_ROOM_TYPE,
        roomTypes: {
          [RoomType.WALK]: true,
          [RoomType.PATIO]: true,
        },
        includeAnyInSameRoomSets: false,
        otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
        exteriorRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
      },
    ],
    exclude: [],
  },
};

export const TotalFloorAreaAndConditionedStairsFirstFloorOnlyV2: FloorAreaTakeoffConfig = {
  include: [
    {
      type: AreaRuleType.BY_ROOM_SELECTOR,
      roomSelectors: [RoomSelectorType.CONDITIONED],
      includeAnyInSameRoomSets: false,
      otherRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
    },
  ],
  exclude: [
    {
      type: AreaRuleType.BY_ROOM_TYPE,
      roomTypes: {
        [RoomType.STAIRS]: true,
        [RoomType.STAIRS_EDITOR]: true,
        [RoomType.OPEN_BELOW]: true,
      },
      includeAnyInSameRoomSets: false,
      otherRoomBorderPosition: BorderPosition.FRAMING_INSIDE,
      appliesOnlyTo: FloorFilter.UPPER_FLOORS_ONLY,
    },
  ],
};

export const TotalFloorAreaAndConditionedV2: FloorAreaTakeoffConfig = {
  include: [
    {
      type: AreaRuleType.BY_ROOM_SELECTOR,
      roomSelectors: [RoomSelectorType.CONDITIONED],
      includeAnyInSameRoomSets: false,
      otherRoomBorderPosition: BorderPosition.FRAMING_OUTSIDE,
    },
  ],
  exclude: [],
};
